import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useObserver } from "mobx-react-lite";
import { useStores } from "../../../store";
import { DownloadResume } from "../resume_output";

const Resume18 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div
        className="flex max-w-[8.5in] mx-auto my-10 bg-white shadow-lg border-l-8 border-[#1b4f72]"
        ref={resumeRef}
      >
        <div className="bg-[#1b4f72] text-white p-6 w-1/3 flex flex-col items-start">
          <div className="mb-6">
            <img
              className="flex w-[125px] h-[125px] mx-auto rounded-full object-cover mb-6"
              src={
                ResumeStore?.resumeBuilder?.profile ||
                "https://via.placeholder.com/120"
              }
              alt="Profile"
            />
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-medium mb-2">Contact</h2>
            <p className="mb-2">
              {ResumeStore?.resumeBuilder.personalDetails.firstName}{" "}
              {ResumeStore?.resumeBuilder.personalDetails.lastName}
            </p>
            <p className="mb-2">
              {ResumeStore?.resumeBuilder.personalDetails.jobTitle}
            </p>
            <p className="mb-2">
              {ResumeStore?.resumeBuilder.personalDetails.phone}
            </p>
            <p className="mb-2">
              {ResumeStore?.resumeBuilder.personalDetails.email}
            </p>
            <p className="mb-2">linkedin.com/in/varunmishra</p>
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-medium mb-2">Skills</h2>
            <ul className="list-disc pl-5">
              {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                <li key={index} className="mb-2">
                  {skill}
                </li>
              ))}
            </ul>
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-medium mb-2">Languages</h2>
            {ResumeStore?.resumeBuilder.languages.map((language, index) => (
              <div key={index} className="mb-2">
                <p className="mb-1">
                  {language.language} - {language.level}
                </p>
                <div className="w-full bg-gray-200 h-2 rounded-full">
                  <div
                    className="h-2 bg-yellow rounded-full"
                    style={{
                      width: `${
                        language.level === "Native"
                          ? "100%"
                          : language.level === "Fluent"
                          ? "90%"
                          : "60%"
                      }`,
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="p-6 w-2/3">
          <header className="mb-6">
            <h1 className="text-4xl font-bold text-[#1b4f72] mb-2">
              {ResumeStore?.resumeBuilder.personalDetails.firstName}{" "}
              {ResumeStore?.resumeBuilder.personalDetails.lastName}
            </h1>
            <h2 className="text-xl font-medium text-gray-600">
              {ResumeStore?.resumeBuilder.personalDetails.jobTitle}
            </h2>
          </header>
          <div className="mb-6">
            <h2 className="text-lg font-medium text-[#1b4f72] mb-2 border-b-2 border-gray-300 pb-1">
              Profile
            </h2>
            <p className="text-gray-800">
              {ResumeStore?.resumeBuilder.profileSummary}
            </p>
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-medium text-[#1b4f72] mb-2 border-b-2 border-gray-300 pb-1">
              Work History
            </h2>
            {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
              <div key={index} className="mb-4">
                <h3 className="text-md font-medium text-[#1b4f72]">
                  {job.jobTitle}
                </h3>
                <p className="text-gray-600">
                  {job.company}, {job.city} | {job.startDate} - {job.endDate}
                </p>
                <ul className="list-disc pl-5">
                  {job.description?.split("\n")?.map((desc, idx) => (
                    <li key={idx} className="text-gray-800">
                      {desc}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-medium text-[#1b4f72] mb-2 border-b-2 border-gray-300 pb-1">
              Education
            </h2>
            {ResumeStore?.resumeBuilder.education.map((edu, index) => (
              <div key={index} className="mb-4">
                <h3 className="text-md font-medium text-[#1b4f72]">
                  {edu.degree}
                </h3>
                <p className="text-gray-600">
                  {edu.school}, {edu.city} | {edu.startDate} - {edu.endDate}
                </p>
                <p className="text-gray-800">{edu.description}</p>
              </div>
            ))}
          </div>
          {/* <div className="mb-6">
            <h2 className="text-lg font-medium text-[#1b4f72] mb-2 border-b-2 border-gray-300 pb-1">Certifications</h2>
            {ResumeStore?.resumeBuilder.certifications.map((cert, index) => (
              <p key={index} className="text-gray-800">{cert}</p>
            ))}
          </div> */}
        </div>
      </div>
    </>
  ));
};

export default Resume18;
